import type { DevProps } from './types';
export const getDefaultDevProps = (): DevProps => {
  return {
    strapiBaseUrl: 'https://strapi.techlockdown.black',
    editButton: {
      editUrl: '/admin/content-manager/collectionType/api::article.article/1',
      text: 'Edit'
    },
    isDev: false
  };
};
